import { IoMdSchool } from "react-icons/io";
import { MdOutlineModeFanOff } from "react-icons/md";
import { FaUniversity } from "react-icons/fa";
import { CgWorkAlt } from "react-icons/cg";
import { IoSunnySharp } from "react-icons/io5";

function timelimeSymbol(type) {
  let icon = <MdOutlineModeFanOff />;
  switch (type) {
    case "school":
      icon = <IoMdSchool />;
      break;
    case "college":
      icon = <FaUniversity />;
      break;
    case "work":
      icon = <CgWorkAlt />;
      break;
    case "event":
      icon = <IoSunnySharp />;
      break;
    default:
      icon = <MdOutlineModeFanOff />;
      break;
  }
  return icon;
}

export default timelimeSymbol;
